@if (!(loadingTpl$|async)||!(stockList$|async)) {
  @if (isPrice) {
    <add-to-cart [addToCartText]="'Add'" [productId]="productId" [fixedLotMultiplier]="fixedLotMultiplier" [minQty]="minQty" [maxQty]="maxQty" [mode]="mode"></add-to-cart>
  } @else {
    <rfq-btn [btnText]="'RFQ'" [pid]="productId" [dataClasses]="'app-btn-l app-btn-hover-d'" [sku]="productSku" [skuText]="skuText"></rfq-btn>
  }
  <ng-template #rfq>
    <rfq-btn [btnText]="'RFQ'" [pid]="productId" [dataClasses]="'app-btn-l app-btn-hover-d'" [sku]="productSku" [skuText]="skuText"></rfq-btn>
  </ng-template>
} @else {
  <contentloader [showTitle]="false"></contentloader>
}
